import { ApolloError, useMutation } from '@apollo/client';
import { DynamicAgentPhoneResultError } from '../graphql.generated';
import { CREATE_DYNAMIC_AGENT_PHONE } from '..';
import {
    CreateDynamicAgentPhoneMutation,
    CreateDynamicAgentPhoneMutationVariables
} from './DynamicNumber.mutation.generated';

type DynamicNumberHookProps = {
    getDynamicNumber: (
        branchId: string,
        listingId: string
    ) => Promise<string | null>;
    dynamicPhone: string | null;
    error: ApolloError | DynamicAgentPhoneResultError | undefined;
    loading: boolean;
};

export const useDynamicNumber = (): DynamicNumberHookProps => {
    let dynamicPhone: string | null = null;
    let error: ApolloError | DynamicAgentPhoneResultError | undefined;
    const [getDynamicNumberMutation, { loading, data, error: mutationError }] =
        useMutation<
            CreateDynamicAgentPhoneMutation,
            CreateDynamicAgentPhoneMutationVariables
        >(CREATE_DYNAMIC_AGENT_PHONE);

    const getDynamicNumber = async (branchId: string, listingId: string) => {
        try {
            const { data } = await getDynamicNumberMutation({
                variables: {
                    input: {
                        branchId: Number(branchId),
                        listingId: Number(listingId)
                    }
                }
            });

            return data?.createDynamicAgentPhone &&
                'phone' in data.createDynamicAgentPhone
                ? data.createDynamicAgentPhone.phone
                : null;
        } catch (e) {
            return null;
        }
    };

    if (mutationError) error = mutationError;

    if (!data) {
        return {
            getDynamicNumber,
            dynamicPhone,
            loading,
            error
        };
    }

    if ('phone' in data.createDynamicAgentPhone) {
        dynamicPhone = data.createDynamicAgentPhone.phone;
    }
    if ('errorCode' in data.createDynamicAgentPhone) {
        error = data.createDynamicAgentPhone;
    }

    return {
        getDynamicNumber,
        dynamicPhone,
        loading,
        error
    };
};
